import React, { createContext, useContext, useState } from "react";
import dynamic from "next/dynamic";

// components
const FirstCampaignModal = dynamic(() => import("@/components/Modals/FirstCampaignModal"), { ssr: false });

// interfaces
import { IFirstCampaignModalContent } from "@/components/Modals/FirstCampaignModal";

const INITIAL_STATE = {
  firstCampaign: {
    open: false,
    spaceId: null,
    spaceName: null,
    period: { start: null, end: null },
    onCancel: () => null,
    onSuccess: () => null,
  }
};

type THandelSetState = {
  modalType: "firstCampaign";
  value: IFirstCampaignModalContent;
} // add - | { modalType: ... } for new modals

export interface IHirerModalsContext {
  state: {
    firstCampaign: IFirstCampaignModalContent;
  };
  setState: (props: THandelSetState) => void;
  resetState: () => void;
}

export const HirerModalsContext = createContext<IHirerModalsContext>({
  state: INITIAL_STATE,
  setState: () => null,
  resetState: () => null,
});

export const useHirerModalsContext = () => {
  const context = useContext(HirerModalsContext);
  if (!context) {
    throw Error("useHirerModalsContext should br used within a HirerModalsContext");
  }

  return context;
};

export function withHirerModalsContext<T extends object>(Component: React.ComponentType<T>) {
  return function WrapperComponent(props: T) {
    const [state, setState] = useState<IHirerModalsContext["state"]>(INITIAL_STATE);
    
  
    // methods
    const handleSetState = ({ modalType, value }: THandelSetState) => {
      if (typeof value === "undefined") {
        return;
      }

      if (modalType === "firstCampaign") {
        setState(prevState => ({ ...prevState, firstCampaign: { ...prevState.firstCampaign, ...(value || {}) } }));
      }
    };
  
    const resetState = () => setState(INITIAL_STATE);

    return (
      <HirerModalsContext.Provider value={{ state, setState: handleSetState, resetState }}>
        <Component { ...(props as T) }/>
        <FirstCampaignModal {...state.firstCampaign }/>
      </HirerModalsContext.Provider>
    );
  };
}
